import { createAsyncThunk } from '@reduxjs/toolkit'
import { GetAllAllergies } from '@services/api/allergy.api'
import type { Allergy } from '@dataTypes/allergy-medical-condition.types'

type AllergyCatalogSliceState = {
  allergiesLoading: boolean
  allergiesLoaded: boolean
}

export const fetchAllergiesCatalog = createAsyncThunk<
  Allergy[],
  void,
  { state: { allergyMedicalCondition: AllergyCatalogSliceState } }
>(
  'allergyMedicalCondition/fetchAllergiesCatalog',
  async () => {
    return GetAllAllergies()
  },
  {
    condition: (_, { getState }) => {
      const { allergiesLoading, allergiesLoaded } =
        getState().allergyMedicalCondition
      if (allergiesLoading || allergiesLoaded) return false
      return true
    },
  },
)
